<template>
    <div>
        <input v-if="edit && type === 'input'" :value="value"
                @input="onInput" :placeholder="placeholder">
        <b-textarea v-if="edit && type === 'textbox'" :value="value" max-rows="5"
                @input="onInput" :placeholder="placeholder"></b-textarea>
        <div v-if="!edit">{{value}}</div>
    </div>
</template>

<script>
export default {
  name: 'switchableInput',
  props: {
    value: String,
    edit: Boolean,
    type: {
      type: String,
      default: 'input'
    },
    placeholder: String
  },
  methods: {
    onInput(evt) {
      this.$emit('input', evt.target.value);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    input,textarea {
        border: 0;
        padding: 0 5px;
        margin: 0;
        border-radius: 0;
        border-bottom: 1px solid transparent;
        width: 100%;

        font-size: 1rem;
        outline: 0 !important;
        -webkit-appearance:none;
        box-shadow: none !important;
        transition: all 0.4s;

        &:hover {
            border-color: $switchable-input-hoverborder;
            background-color: $switchable-input-hoverbackground;
        }
        &:focus {
            border-color: $switchable-input-focusborder;
            background-color: $switchable-input-focusbackground;
        }
    }
    input {
        line-height: 1;
        height: 1.5em;

    }
    textarea {
        border: 1px solid transparent;
        border-radius: 2px;
    }

    div {
        margin: 0 5px;
        white-space: pre;
    }
</style>
